var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.18 45.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #02808d;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.59,15.06c-2,0-3.91.79-5.32,2.21-1.41,1.41-2.21,3.33-2.21,5.32s.79,3.91,2.21,5.32c1.41,1.41,3.33,2.21,5.32,2.21s3.91-.79,5.32-2.21c1.41-1.41,2.21-3.33,2.21-5.32s-.79-3.91-2.21-5.32c-1.41-1.41-3.33-2.21-5.32-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.92,22.59c0-3.09,1.23-6.06,3.42-8.24,2.19-2.19,5.16-3.41,8.25-3.41s6.07,1.23,8.25,3.41c2.19,2.19,3.42,5.15,3.42,8.24s-1.23,6.06-3.42,8.24c-2.19,2.19-5.16,3.41-8.25,3.41s-6.07-1.23-8.25-3.41c-2.19-2.19-3.42-5.15-3.42-8.24Zm23.96-14.72c-.65,0-1.28.26-1.74.72-.46.46-.72,1.08-.72,1.73s.26,1.27.72,1.73c.46.46,1.09.72,1.74.72s1.28-.26,1.74-.72c.46-.46.72-1.08.72-1.73s-.26-1.27-.72-1.73c-.46-.46-1.09-.72-1.74-.72ZM9.74.71C18.28-.24,26.9-.24,35.44.71c4.67.52,8.43,4.19,8.98,8.86,1.01,8.65,1.01,17.38,0,26.03-.55,4.68-4.31,8.34-8.98,8.87-8.54.95-17.17.95-25.71,0-4.67-.52-8.43-4.19-8.98-8.86C-.25,26.96-.25,18.22.76,9.57,1.31,4.9,5.07,1.23,9.74.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgNew);
export default __webpack_public_path__ + "static/media/ig-new.1d656ab2ae4208cd4d411f0efa5d0620.svg";
export { ForwardRef as ReactComponent };